import * as React from "react";
import styled from "@mui/material/styles/styled";
import { Button, Menu, MenuItem } from "@mui/material";
import Fade from "@mui/material/Fade";
import { MeasurementUnits } from "fe-common/graphql";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

//region [[ Styles ]]

const LevelNumericUnitSelectMenuView = styled("div")(({ theme }) => ({}));

const MenuButton = styled(Button)(({ theme }) => ({
  fontSize: "12px",
  width: "120px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LevelNumericUnitSelectMenuProps {
  value: MeasurementUnits;
  onSelect: (unit: MeasurementUnits) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LevelNumericUnitSelectMenu = ({
  ...props
}: LevelNumericUnitSelectMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event, unit) => {
    setAnchorEl(null);
    props.onSelect(unit);
  };

  return (
    <LevelNumericUnitSelectMenuView>
      <MenuButton
        aria-controls="fade-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {props.value}
        <ArrowDropDownIcon />
      </MenuButton>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {Object.keys(MeasurementUnits).map((unit) => (
          <MenuItem
            onClick={(event) => {
              handleClose(event, unit);
            }}
          >
            {unit}
          </MenuItem>
        ))}
      </Menu>
    </LevelNumericUnitSelectMenuView>
  );
};
